<script setup lang="ts">
import { type PropType } from 'vue'
import type { AdminConfiguratorType } from '@/entities/Cabinet'
import { VIcons } from '@/shared/ui'
import { useConfiguratorMove } from './../model/api'
import { useRoute } from 'vue-router'

const props = defineProps({
  item: {
    type: Object as PropType<AdminConfiguratorType>,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  items: {
    type: Array as PropType<AdminConfiguratorType[]>,
    required: true,
  },
})

const route = useRoute()
const emits = defineEmits(['updated'])

const { move } = useConfiguratorMove(Number(route.params.object_id))

/**
 * Обработка перемещения конфигурации
 * @param direction
 */
const clickHandler = async (direction: string) => {
  let target = direction === 'up' ? props.items[props.index - 1] : props.items[props.index + 1]

  if (target) {
    await move({
      target_id: target.id,
      main_id: props.item.id,
    })

    emits('updated')
  }
}
</script>

<template>
  <VBtn v-if="index != 0" icon density="compact" color="default" @click="clickHandler('up')">
    <VIcons type="arrow_upward" />
  </VBtn>

  <VBtn
    v-if="index < items.length - 1"
    icon
    density="compact"
    color="default"
    @click="clickHandler('down')"
  >
    <VIcons type="arrow_downward" />
  </VBtn>
</template>
